import React, { Fragment } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { formatUSD } from '@sparefoot/react-core/utils/format';

import { unitPropType } from 'config/propTypes';
import { Link } from 'components/core/Link';
import { Paragraph, Text } from 'components/core/Typography';

export function StackedUnit({ unit, withScarcity }) {
	return (
		<div className="stacked-unit">
			{unit.quantity === 0 && (
				<div className="unit-description">
					<Paragraph className="unit-size-type scarcity">
						No <span className="unit-size">{unit.size}</span> Units
						Available
					</Paragraph>
				</div>
			)}
			{(unit.quantity || unit.quantity == null) && (
				<Fragment>
					<div className="unit-description">
						<Paragraph className="unit-size-type">
							<span className="unit-size">{unit.size}</span>{' '}
							{unit.typeText}
						</Paragraph>
						{unit.availableAmenities && (
							<Paragraph className="unit-amenities">
								{unit.availableAmenities.join(', ')}
							</Paragraph>
						)}
						{!!unit.special && (
							<Paragraph
								className="unit-promo"
								last
							>
								{unit.special}
							</Paragraph>
						)}
						{!unit.special && unit.vehicleAccommodation && (
							<Paragraph
								className="vehicle-accommodation"
								last
							>
								{unit.vehicleAccommodation}
							</Paragraph>
						)}
					</div>
					<div className="unit-price">
						<Link
							className="unit-price-link"
							to={unit.url}
							productClick
							rel="nofollow"
							ecommerceProps={{
								price: get(unit, 'price.meta', ''),
							}}
							trackEcommerceClick
						>
							{!!unit.isOutOfBookingRange && (
								<div>
									<div className="out-of-range">
										Out of date range
									</div>
									<div className="view-anyway">
										View Anyway
									</div>
								</div>
							)}
							{withScarcity &&
							!unit.isOutOfBookingRange &&
							unit.quantity < 4 &&
							unit.quantity ? (
								<div className="scarcity-price">
									<Text
										color="red"
										size="tiny"
										last
									>
										{unit.quantity} left at
									</Text>
									<Text
										className="effective-price"
										size="small"
										color="red"
										last
									>
										{formatUSD(unit.price.meta)}
									</Text>
								</div>
							) : (
								<span className="effective-price">
									{formatUSD(unit.price.meta)}
								</span>
							)}
						</Link>
					</div>
				</Fragment>
			)}
		</div>
	);
}

StackedUnit.propTypes = {
	facilityId: PropTypes.number.isRequired,
	unit: unitPropType.isRequired,
	withScarcity: PropTypes.bool,
};

export default StackedUnit;
